export default __webpack_public_path__ + "static/media/adsform-top-bg.34dc2dfa.jpg";